import styled from '@emotion/styled';
import H3 from '@base/H3/H3';
import { Spacings, breakpoints } from '@styles/index';
import P1 from '@base/P1/P1';
import { getImage } from '@utils/imageHelper';

const EnvelopeImg = styled.img`
  margin: ${Spacings.SPACING_13B} auto ${Spacings.SPACING_8B};
  @media only screen and (max-width: ${breakpoints.mobile}) {
    margin: ${Spacings.SPACING_8B} auto ${Spacings.SPACING_8B};
  }
`;

const StyH3 = styled(H3)`
  margin: 0 auto ${Spacings.SPACING_2B};
  text-align: center;
`;

const StyP1 = styled(P1)`
  text-align: center;
`;

const Success = () => {
  return (
    <>
      <EnvelopeImg
        src={getImage('physical-notes/envelope.svg')}
        width={Spacings.SPACING_32B}
        alt="success"
      />
      <StyH3>We’ve recorded your address details</StyH3>
      <StyP1>
        You will be informed at the time of dispatch of the packages
      </StyP1>
    </>
  );
};

export default Success;
